import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const newsEventsCarousels = document.querySelectorAll(
    '.carrousel-expertise .carrousel-expertise__carousel'
  );

  if (0 < newsEventsCarousels.length) {
    newsEventsCarousels.forEach((newsEventsCarousel) => {
      new Swiper(newsEventsCarousel, {
        slidesPerView: 1.1,
        spaceBetween: 18,
        navigation: {
          nextEl: '.carrousel-expertise__next.swiper-button-next',
          prevEl: '.carrousel-expertise__prev.swiper-button-prev',
        },
        breakpoints: {
          1024: {
            slidesPerView: 1.5,
            spaceBetween: 20,
          },
          1240: {
            slidesPerView: 2.25,
          },
        },
      });
    });
  }
});
